import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { PWAState } from "./types";

export const pwaSlice = createSlice({
	name: "pwa",
	initialState,
	reducers: {
		setHasCompletedPWAInit: (state, action: PayloadAction<boolean>) => {
			state.hasCompletedPWAInit = action.payload;
		}
	}
});

export const { setHasCompletedPWAInit } = pwaSlice.actions;

export default pwaSlice.reducer;

export const selectPWAState = (state: { pwa: PWAState }): PWAState => state.pwa;
